import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { RC_ICON } from "../lib/constants";
import { useLang } from "../lib/i18n";
import { LanguageToggle } from "../components/CommunitySelection";
import { Printer } from "lucide-react";

export default function Poster() {
  const { t } = useLang();
  const appUrl = `${window.location.origin}/`;
  return (
    <div className="min-h-screen bg-[var(--page)] py-8 px-4">
      <div className="max-w-md mx-auto">
        <div className="flex justify-between items-center mb-4 print:hidden">
          <LanguageToggle variant="light" />
          <button
            data-testid="print-poster-button"
            onClick={() => window.print()}
            className="inline-flex items-center gap-2 bg-vin text-white text-sm font-semibold px-4 py-2 rounded-full hover:bg-vin-hover transition-colors duration-200"
          >
            <Printer className="w-4 h-4" strokeWidth={1.75} /> {t("Print poster")}
          </button>
        </div>

        {/* Poster */}
        <div className="bg-white rounded-lg border border-[var(--line)] overflow-hidden">
          <div className="bg-vin-dark px-8 py-10 text-center">
            <img src={RC_ICON} alt="Root Causes Challenge" className="h-20 w-20 mx-auto bg-white rounded-2xl p-1" />
            <p className="mt-5 text-xs uppercase tracking-[0.24em] font-semibold text-white/70">
              {t("An Interactive Poverty Simulation")}
            </p>
            <h1 className="mt-3 font-display text-3xl font-semibold text-white leading-tight">
              {t("Root Causes Challenge")}
            </h1>
            <p className="mt-4 text-white/85 leading-relaxed">
              {t("Take a 2-minute snapshot at our table — walk in the shoes of a neighbor experiencing poverty.")}
            </p>
          </div>

          <div className="px-8 py-9 text-center">
            <div className="inline-block p-4 bg-white border-2 border-vin/15 rounded-lg">
              <QRCodeCanvas value={appUrl} size={220} fgColor="#2C2117" level="M" includeMargin={false} />
            </div>
            <p className="mt-6 font-display text-xl font-semibold text-ink">{t("Scan & try it now")}</p>
            <p className="mt-2 text-sm text-ink-soft leading-relaxed">
              {t("A 2-minute snapshot · or walk a full year · no sign-in · completely anonymous")}
            </p>
            <p className="mt-5 text-sm text-ink leading-relaxed max-w-xs mx-auto">
              {t("A formation experience to help us understand the root causes of poverty — and work toward a more just community.")}
            </p>
            <p className="mt-6 text-[11px] text-ink-soft break-all">{appUrl}</p>
            <p className="mt-4 text-[11px] text-ink-soft leading-relaxed">
              {t("Designed and Developed by Matambanadzo Studio")}
            </p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-soft print:hidden">
          {t("Tip: print this page, or take a photo to share the QR code.")}
        </p>
      </div>
    </div>
  );
}
